import {
    ActionType,
    deleteUserAction,
    getUserInformationAction,
    getUserListAction,
    initUserInformationAction,
    registerUserInformationAction,
    updateUserInformationAction
} from "./actions";
import { ViewableCareRecipientsJson } from "../../../../domain/care_recipient/CareRecipient";
import { UserInformationJson, UserListJson } from "../../../../domain/user/User";
import { createSlice } from "@reduxjs/toolkit";

export type AdminUserState = Readonly<{
    users: UserListJson | null,
    userInformation: UserInformationJson | null,
    viewableCareRecipients: ViewableCareRecipientsJson | null,
    processing: number,
    userInformationRegisterFailed: boolean
}>;

const adminUserInitialState: AdminUserState = {
    users: null,
    userInformation: null,
    viewableCareRecipients: null,
    processing: 0,
    userInformationRegisterFailed: false
};
const slice = createSlice({
    name: ActionType.base,
    initialState: adminUserInitialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(
                getUserListAction.pending,
                (state) => {
                    state.users = null;
                    state.processing += 1;
                }
            )
            .addCase(
                getUserListAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    state.users = payload.users;
                    state.processing -= 1;
                }
            )
            .addCase(
                getUserListAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                getUserInformationAction.pending,
                (state) => {
                    state.userInformation = null;
                    state.viewableCareRecipients = null;
                    state.processing += 1;
                }
            )
            .addCase(
                getUserInformationAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    state.userInformation = payload.userInformation;
                    state.viewableCareRecipients = payload.viewableCareRecipients;
                    state.processing -= 1;
                }
            )
            .addCase(
                getUserInformationAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                initUserInformationAction,
                (state) => {
                    state.viewableCareRecipients = null;
                    state.userInformationRegisterFailed = false;
                }
            )
            .addCase(
                registerUserInformationAction.pending,
                (state) => {
                    state.processing += 1;
                    state.userInformationRegisterFailed = false;
                }
            )
            .addCase(
                registerUserInformationAction.fulfilled,
                (state) => {
                    state.users = null;
                    state.processing -= 1;
                    state.userInformationRegisterFailed = false;
                }
            )
            .addCase(
                registerUserInformationAction.rejected,
                (state) => {
                    state.processing -= 1;
                    state.userInformationRegisterFailed = true;
                }
            )
            .addCase(
                updateUserInformationAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                updateUserInformationAction.fulfilled,
                (state) => {
                    state.users = null;
                    state.processing -= 1;
                }
            )
            .addCase(
                updateUserInformationAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            )
            .addCase(
                deleteUserAction.pending,
                (state) => {
                    state.processing += 1;
                }
            )
            .addCase(
                deleteUserAction.fulfilled,
                (state, action) => {
                    const { payload } = action;
                    const { userId } = payload;
                    state.users = state.users?.filter( user => user.id !== userId) ?? [];
                    state.processing -= 1;
                }
            )
            .addCase(
                deleteUserAction.rejected,
                (state) => {
                    state.processing -= 1;
                }
            );
    }
});

export const adminUserReducer = slice.reducer;
